module.exports = __webpack_public_path__ + "img/shipping_type_5.b1de2e0.webp";